import { render, staticRenderFns } from "./limit_time_discount_edit.vue?vue&type=template&id=ceea3272&scoped=true"
import script from "./limit_time_discount_edit.vue?vue&type=script&lang=js"
export * from "./limit_time_discount_edit.vue?vue&type=script&lang=js"
import style0 from "./limit_time_discount_edit.vue?vue&type=style&index=0&id=ceea3272&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceea3272",
  null
  
)

export default component.exports